var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Build/application"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    d: "M19.2594 11.333V20.4997H14.5M4.59277 11.333V20.4997H9.5M9.5 20.4997V16C11.5 14 12.2959 13.9092 14.5 16V20.4997M9.5 20.4997H14.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 18",
    d: "M3.58625 7.56429C2.88521 9.37977 4.23744 11.3333 6.18357 11.3333V11.3333C7.70235 11.3333 8.94203 10.1021 8.94203 8.58333V8.58333V8.58333C8.94203 10.1021 10.1733 11.3333 11.692 11.3333H12.1588C13.6776 11.3333 14.9088 10.1021 14.9088 8.58333V8.58333V8.58333C14.9088 10.1021 16.149 11.3333 17.6677 11.3333V11.3333C19.6149 11.3333 20.9684 9.37862 20.2668 7.56229L18.8906 4H4.96259L3.58625 7.56429Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.e739529bed556540e2cdd9ca3f4bbd90.svg";
export { ForwardRef as ReactComponent };